module.exports = __webpack_public_path__ + "img/onecake-feature.41a61d82.jpg";